import { render, staticRenderFns } from "./shop-notify-customer.vue?vue&type=template&id=71b4c707&scoped=true&"
import script from "./shop-notify-customer.vue?vue&type=script&lang=js&"
export * from "./shop-notify-customer.vue?vue&type=script&lang=js&"
import style0 from "./shop-notify-customer.vue?vue&type=style&index=0&id=71b4c707&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b4c707",
  null
  
)

export default component.exports